import * as React from "react";
import { Translate } from "react-localize-redux";
import { translationKeys } from "../../../../gen/translation-keys";
import { TextKeys, TextField } from "./TextField";

interface EmailFormFieldProps {
  disabled?: boolean;
  fieldName: TextKeys;
  label?: React.ReactNode;
}
const EmailFormField: React.FC<EmailFormFieldProps> = ({
  disabled,
  fieldName,
  label
}) => {
  return (
    <Translate>
      {({ translate }) => (
        <TextField
          disabled={disabled}
          fieldName={fieldName}
          label={label}
          fullWidth
          fieldOptions={{
            required: translate(
              translationKeys.document_page.send_document_link_to_email_required
            ).toString(),
            pattern: {
              value:
                /^(([^<>()[\]\\.,;:\s@&"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(;.+))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
              message: translate(
                translationKeys.document_page
                  .send_document_link_to_email_invalid
              ).toString()
            },
            maxLength: {
              value: 250,
              message: translate(
                translationKeys.document_page
                  .send_document_link_to_email_too_long
              ).toString()
            }
          }}
        />
      )}
    </Translate>
  );
};

export default EmailFormField;
